import React, { Component } from 'react';
import { Form, Select, Spin, Tooltip } from 'antd';
import debounce from 'lodash/debounce';
import uniqBy from 'lodash/uniqBy';
import PropTypes from 'prop-types';
import { AddFormItemLabel, AddSelector } from 'utils';
const FormItem = Form.Item;
const Option = Select.Option;

export default class CountriesSelectV2 extends Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    handleCountryChange: PropTypes.func,
    countryValue: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  };

  render() {
    const { handleCountryChange, countryValue, disabled } = this.props;
    return (
      <>
        {disabled ? (
          <Tooltip>
            <FormItem
              name="country"
              label={<AddFormItemLabel>Dein Land</AddFormItemLabel>}
              required={false}
              rules={[
                {
                  required: true,
                  message: 'Bitte gib dein Land ein.',
                },
              ]}
              extra="Dein Wohnsitz bzw. der rechtliche Sitz deiner Organisation."
            >
              <AddSelector
                value={countryValue}
                placeholder="Land eingeben"
                options={[
                  { value: 'DE', label: 'Deutschland' },
                  { value: 'AT', label: 'Österreich' },
                  { value: 'CH', label: 'Schweiz' },
                ]}
                onChange={handleCountryChange}
                style={{ width: '100%' }}
                disabled={true}
              />
            </FormItem>
          </Tooltip>
        ) : (
          <FormItem
            name="country"
            label={<AddFormItemLabel>Dein Land</AddFormItemLabel>}
            required={false}
            rules={[
              {
                required: true,
                message: 'Bitte gib dein Land ein.',
              },
            ]}
            extra="Dein Wohnsitz bzw. der rechtliche Sitz deiner Organisation."
          >
            <AddSelector
              value={countryValue}
              placeholder="Land eingeben"
              options={[
                { value: 'DE', label: 'Deutschland' },
                { value: 'AT', label: 'Österreich' },
                { value: 'CH', label: 'Schweiz' },
              ]}
              onChange={handleCountryChange}
              style={{ width: '100%' }}
            />
          </FormItem>
        )}
      </>
    );
  }
}
